/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRules.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRulesTestIds = {
  btnDetectionHistory: "btn-detection-history",
  colDeniedProfiles: "col-denied-profiles",
  colName: "col-name",
  colOwner: "col-owner",
  colStatus: "col-status",
  colViolations: "col-violations",
  restrictionRulesList: "restriction-rules-list",
  linkRule: (rule_id: string) => `link-rule-${rule_id}`,
  linkRulePrefix: () => "link-rule-" as TestIdPrefix,
  linkViolations: (rule_id: string) => `link-violations-${rule_id}`,
  linkViolationsPrefix: () => "link-violations-" as TestIdPrefix,
  rowRule: (rule_id: string) => `row-rule-${rule_id}`,
  rowRulePrefix: () => "row-rule-" as TestIdPrefix,
  ruleOwner: (rule_id: string) => `rule-owner-${rule_id}`,
  ruleOwnerPrefix: () => "rule-owner-" as TestIdPrefix,
  ruleProfileCount: (rule_id: string) => `rule-profile-count-${rule_id}`,
  ruleProfileCountPrefix: () => "rule-profile-count-" as TestIdPrefix,
  ruleStatus: (rule_id: string) => `rule-status-${rule_id}`,
  ruleStatusPrefix: () => "rule-status-" as TestIdPrefix,
  ruleViolationCount: (rule_id: string) => `rule-violation-count-${rule_id}`,
  ruleViolationCountPrefix: () => "rule-violation-count-" as TestIdPrefix
} as const;
